export const GET_DICTIONARY_PUBLISHED_SCHEDULES = Symbol('GET_DICTIONARY_PUBLISHED_SCHEDULES');
export const GET_DICTIONARY_PUBLISHED_SCHEDULES_REQUEST = Symbol('GET_DICTIONARY_PUBLISHED_SCHEDULES_REQUEST');
export const GET_DICTIONARY_PUBLISHED_SCHEDULES_SUCCESS = Symbol('GET_DICTIONARY_PUBLISHED_SCHEDULES_SUCCESS');
export const GET_DICTIONARY_PUBLISHED_SCHEDULES_ERROR = Symbol('GET_DICTIONARY_PUBLISHED_SCHEDULES_ERROR');

